module.exports = __webpack_public_path__ + "img/software.cb1c7b51.png";